const _documentType = {
  DRAFT: 'Draft',
  REVIEW: 'Review',
  PUBLISHED: 'Published',
  EDIT: 'Edit',
};

export default Object.freeze(_documentType);
